import { render, staticRenderFns } from "./CurrentTariffContent.vue?vue&type=template&id=6ba4719e&scoped=true"
import script from "./CurrentTariffContent.vue?vue&type=script&lang=ts"
export * from "./CurrentTariffContent.vue?vue&type=script&lang=ts"
import style0 from "./CurrentTariffContent.vue?vue&type=style&index=0&id=6ba4719e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba4719e",
  null
  
)

export default component.exports